import { combineReducers } from 'redux'
import { DOCUMENTS_RECEIVED, DOCUMENT_RECEIVED } from './actions'

const allIds = (state = [], action) => {
  const { type, payload } = action
  switch (type) {
    case DOCUMENTS_RECEIVED:
      if (payload == null) throw new Error('No documents')
      return [...state, ...payload.map(document => document.id)]
    case DOCUMENT_RECEIVED:
      if (payload == null) throw new Error('No document')
      return [...state, payload.id]
    default:
      return state
  }
}

const byId = (state = {}, action) => {
  const { type, payload } = action
  switch (type) {
    case DOCUMENTS_RECEIVED:
      return {
        ...state,
        ...payload.reduce(
          (s, document) => ({
            ...s,
            [document.id]: document
          }),
          {}
        )
      }
    case DOCUMENT_RECEIVED:
      return { ...state, [payload.id]: payload }
    default:
      return state
  }
}

export default combineReducers({
  allIds,
  byId
})

export const getAllDocuments = state =>
  state.documents.allIds.map(id => state.documents.byId[id])

export const getDocumentsFromPatientId = (state, patientId) =>
  getAllDocuments(state).filter(
    document =>
      document.subject &&
      document.subject.identifier &&
      document.subject.identifier.value &&
      document.subject.identifier.value === patientId
  )

export const getLastDocumentFromPatientId = (state, patientId, authorId) =>
  getDocumentsFromPatientId(state, patientId)
    .sort(
      (a, b) => new Date(a.created).getTime() > new Date(b.created).getTime()
    )
    .filter(document => document.author.identifier.value === authorId)
    .slice(-1)[0]



// WEBPACK FOOTER //
// ./src/Documents/ducks.js